module.exports = __webpack_public_path__ + "img/gabriela.1962c8f6.png";